import Vue from "vue";
import Element from "element-ui";
import "@/styles/element-variables.scss";
import locale from "element-ui/lib/locale/lang/en";

import Cookies from "js-cookie";

Vue.use(Element, {
  locale,
  size: Cookies.get("size") || "medium", // set element-ui default size
});
